import { addStepToGraph, cloneWorkflowGraph, newGraphStep } from '../graph/index.js';

// D2 (ADR-0001) — applies a placement descriptor from `resolveExitPlacement`. The descriptor is
// explicit, so this never re-infers topology.
//
// PURE: the supplied `graph` is never mutated. We clone first and return the new graph, so the
// helper's contract holds on its own (ADR-0001: "input graph not mutated") rather than depending
// on every caller pre-cloning. `addStepToGraph` mutates in place, so it only ever sees the clone.

export const applyExitPlacement = ({ graph, stepId, placement }) => {
  const nextGraph = cloneWorkflowGraph(graph);

  if (placement?.kind === 'create-root') {
    return addStepToGraph({ graph: nextGraph, stepId, parentStepId: null, relation: 'exit' });
  }

  if (placement?.kind === 'splice-after-parent') {
    return addStepToGraph({ graph: nextGraph, stepId, parentStepId: placement.parentStepId, relation: 'exit' });
  }

  if (placement?.kind === 'prepend-before-root') {
    nextGraph[stepId] = newGraphStep(placement.rootStepId, 'exit');
    return nextGraph;
  }

  throw new Error(`applyExitPlacement: unsupported placement kind "${placement?.kind}".`);
};
